import React, { useState, useEffect } from 'react';

const UrlFormResult = ({inputUrl,afterUrl,onMoreProcess}) => {

  const [isCopied, setIsCopied] = useState(false); // コピーの状態を管理

  const resetUrls = () =>{
    onMoreProcess('');
  }

  const copyUrl = async () => {
     try {
      await navigator.clipboard.writeText('https://ffxiv.link/'+afterUrl);
      setIsCopied(true); // コピー成功
    } catch (err) {
      console.error('クリップボードへのコピーに失敗しました', err);
    }
  }
  // コピー成功後、一定時間でポップアップを消す
  useEffect(() => {
    if (isCopied) {
      const timer = setTimeout(() => {
        setIsCopied(false);
      }, 2000); // 2秒後に非表示にする
      return () => clearTimeout(timer); // クリーンアップ関数
    }
  }, [isCopied]);

  if (!afterUrl) {
    return null;
  }

  return (
    <section id="regist">
      <div id="regist_inner">
        <h2>短縮URL</h2>
        {isCopied && <div className="copy-popup">URLをコピーしました</div>}
        <input id="after_url" type="text" name="after_url" value={`https://ffxiv.link/${afterUrl}`} readOnly onClick={copyUrl} />
        <p className="before">上記の短縮URLをクリックするとクリップボードに保存されます。<br />短縮前のURL：<span id="number_url">{inputUrl}</span></p>
        <button className="submit" onClick={resetUrls}>もう一度入力する</button>
      </div>
    </section>
  );
};

export default UrlFormResult;